/**
 * Deterministic avatar color from user id (or any string).
 * Same id always returns the same color so the same user shows the same color everywhere (chat, list, header).
 */

const AVATAR_PALETTE = [
    { bg: 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)', color: '#fff' }, // orange
    { bg: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: '#fff' }, // blue
    { bg: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)', color: '#fff' }, // green
    { bg: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)', color: '#fff' }, // teal
    { bg: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', color: '#fff' }, // violet
    { bg: 'linear-gradient(135deg, #ec4899 0%, #db2777 100%)', color: '#fff' }, // pink/rose
    { bg: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)', color: '#1c1917' }, // amber
    { bg: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', color: '#fff' }, // indigo
    { bg: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: '#fff' }, // red
    { bg: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', color: '#fff' }, // sky
];

function hashString(str) {
    if (!str || typeof str !== 'string') return 0;
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        h = (h << 5) - h + c;
        h |= 0;
    }
    return Math.abs(h);
}

/**
 * @param {string} id - User id, email, or any stable string for the same person
 * @returns {{ bg: string, color: string }} - Background (gradient) and text color for avatar
 */
export function getAvatarColor(id) {
    const index = hashString(String(id)) % AVATAR_PALETTE.length;
    return AVATAR_PALETTE[index];
}
